import fsg from "@/api/base";

export default {
  get_token(user){
    return fsg.post("/login", {"email": user.email, "password": user.password})
  }
}
